import { Map, OrderedMap } from 'immutable';

import * as types from './types';
import { FailureTestRecord } from '../../records';

const initialState = Map({
  items: OrderedMap(),
  getTestsError: null,
  fetchStatus: 'idle',
});

const failureAnalysisReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.GET_FAILURE_TESTS.REQUEST:
      return state.withMutations((newState) => {
        newState
          .set('fetchStatus', 'loading')
          .set('items', initialState.get('items'));
      });
    case types.GET_FAILURE_TESTS.SUCCESS:
      return state.withMutations((newState) => {
        const items = OrderedMap(
          payload.results.reduce((acc, item) => ({
            ...acc,
            [item.id]: new FailureTestRecord({
              id: item.id,
              name: item.name,
              description: item.description,
              testCount: item.count,
              rootCauseUrl: item.root_causes_url,
              framework: item.framework,
            }),
          }), {}),
        );
        newState.set('items', items);
        newState.set('fetchStatus', 'succeeded');
        newState.set('getTestsError', null);
      });
    case types.GET_FAILURE_TESTS.FAILURE:
      return state.withMutations((newState) => {
        newState
          .set('getTestsError', payload)
          .set('fetchStatus', 'failed');
      });
    case types.CLEANUP:
      return initialState;
    case types.GET_ROOT_CAUSES.REQUEST:
      return state.setIn(['items', payload.index, 'loading'], true);
    case types.GET_ROOT_CAUSES.SUCCESS:
      return state.withMutations((newState) => {
        newState
          .setIn(['items', payload.index, 'loading'], false)
          .setIn(['items', payload.index, 'rootCauses'], payload.results);
      });
    case types.GET_ROOT_CAUSES.FAILURE:
      return state.setIn(['items', payload.index, 'loading'], false);
    default:
      return state;
  }
};

export default failureAnalysisReducer;
export { initialState };
